import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import { searchOrdered, getUI, getApp } from '../selectors';
import ClientList from './ClientList';

export class ClientListContainer extends Component {
  componentDidMount() {
    this.props.fetchClientsIfNeeded();
    this.props.setActive(null);
  }

  handleSearchChange = e => {
    this.props.setSearch(e.target.value);
  };

  render() {
    const { ui } = this.props;
    return (
      <ClientList
        clients={this.props.clients.toList()}
        isLoading={ui.get('isLoading')}
        isError={ui.get('isError')}
        errorMessage={ui.get('errorMessage')}
        searchTerm={this.props.app.get('search')}
        onSearchChange={this.handleSearchChange}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  clients: searchOrdered,
  ui: getUI,
  app: getApp
});

export default connect(mapStateToProps, actions)(ClientListContainer);



// WEBPACK FOOTER //
// ./src/modules/clients/components/ClientListContainer.js